export default __webpack_public_path__ + "assets/6da7a96c6bd8a60c4cbd5924db710358.png";